import React, { memo, useContext, useEffect, useState } from 'react';
import { Table, ActionIcon, Select, Pagination, Image, LoadingOverlay } from '@mantine/core';
import { IoTrashOutline } from "react-icons/io5";
import { FaRegEdit } from "react-icons/fa";
import classes from "./Tableverticals.module.css";
import { useNavigate } from 'react-router-dom';
import useFetch from '../../../Customhooks/useFetch';
import { baseUrl } from '../../../Constants/constant';
import { useDisclosure } from '@mantine/hooks';
import DeleterowData from '../../../CustomComponent/DeleteTableRow/DeleteTableRow.component';
import { authContext } from '../../../context/AuthProvider.component';

function TableVerticals({ editLink, search }: any) {
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [refresh, setRefresh] = useState<number>(0);
  const [selectedId, setSelectedId] = useState<number | null>(null);

  const [confirmDeleteOpened, { open: openConfirmDelete, close: closeConfirmDelete }] = useDisclosure(false);
  const [successModalOpened, { open: openSuccessModal, close: closeSuccessModal }] = useDisclosure(false);

  const navigate = useNavigate();
  const { setError, inputRefresh }: any = useContext(authContext);
  const token = localStorage.getItem("token");
  const updatedUrl = baseUrl.replace("/api/", "");


  const { data: datalist, loading: listLoading, error: getlistError, fetchData: gettable } = useFetch({
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      token: token,
    },
  });

  useEffect(() => {
    gettable(`${baseUrl}admin/verticals?page=${page}&limit=${limit}&search=${search}`);
  }, [page, limit, search, refresh]);
  useEffect(() => {
    if (inputRefresh > 0) {
      setRefresh(inputRefresh);
    }
  }, [inputRefresh]);
  useEffect(() => {
    if (getlistError) {
      setError(getlistError?.message)
    }
  }, [getlistError]);

  const handleClickEdit = (id: number) => {
    navigate(`${editLink}/${id}`);
  };

  const handleClickDelete = async (id: number) => {
    setSelectedId(id);
    openConfirmDelete();
  };
  const handleCloseSuccessModal = () => {
    setRefresh(prev => prev + 1);
    closeSuccessModal();
  };

  const rows = datalist?.data?.rows?.map((el: any) => (
    <Table.Tr key={el.vertical_id}>
      <Table.Td className={classes.icon}>
        <Image fit="contain" src={`${updatedUrl}${el.icon_name}`} alt="icon" />
      </Table.Td>

      <Table.Td>{el.vertical_name}</Table.Td>
      <Table.Td>
        <ActionIcon color="#404040" variant="subtle" onClick={() => handleClickEdit(el.vertical_id)}>
          <FaRegEdit size={16} />
        </ActionIcon>
        <ActionIcon color="red" variant="subtle" onClick={() => handleClickDelete(el.vertical_id)}>
          <IoTrashOutline size={16} />
        </ActionIcon>
      </Table.Td>
    </Table.Tr>
  ));

  const totalPages = Math.ceil((datalist?.data?.count || 0) / limit);

  return (
    <div style={{ padding: '10px' }}>
      <LoadingOverlay
        visible={listLoading}
        zIndex={1000}
        overlayProps={{
          radius: 'sm',
          blur: 2,
          style: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%'
          }
        }}
        loaderProps={{ color: '#404040', type: 'bars' }}
      />
      {/* Table */}
      <Table striped className={classes.customtable}>
        <Table.Thead>
          <Table.Tr style={{ backgroundColor: '#4040401A' }}>
            <Table.Th>Icons</Table.Th>
            <Table.Th>Category Name</Table.Th>
            <Table.Th>Action</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {datalist?.data?.rows?.length < 1 ? (
            <Table.Tr>
              <Table.Td colSpan={3} style={{ textAlign: 'center', fontSize: '17px' }}>No data Available </Table.Td>
            </Table.Tr>
          ) : (
            rows
          )}
        </Table.Tbody>
      </Table>
      {getlistError && <p style={{ color: 'red' }}>Error: {getlistError.message}</p>}

      {/* Pagination */}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
        <Select
          data={[
            { value: '5', label: '05 per page' },
            { value: '10', label: '10 per page' },
            { value: '20', label: '20 per page' },
          ]}
          value={limit.toString()}
          onChange={(value) => setLimit(Number(value))}
          style={{ width: '150px' }}
        />
        <Pagination total={totalPages} value={page} onChange={setPage} color="#404040" />
      </div>
      <DeleterowData
        isConfirmOpen={confirmDeleteOpened}
        isSuccessOpen={successModalOpened}
        closeConfirm={closeConfirmDelete}
        closeSuccess={handleCloseSuccessModal}
        selectedId={selectedId}
        onDeleteSuccess={openSuccessModal}
        url={'admin/verticals/delete/'}
      />
    </div>
  );
}

export default memo(TableVerticals);
